export default __webpack_public_path__ + "static/legibility-dont-7c059f88ce0baae4de0d5560f2f773182e234d51d569140cab9499849cba7ee2.png";